<template>
  <div class="twopage">
    <img class="background-img" src="/assets/~/media/images/activity/film2505-prod/mob/1.jpg">
    <div  class="play-audio" @click="handleAudio">
      <img v-if="isAudioPlaying" style="width: calc(28 / 375 * 100vw);height:calc(17 / 375 * 100vw);margin-top:calc(12 / 375 * 100vw);margin-left:calc(11 / 375 * 100vw)"
       src="/assets/~/media/images/activity/film2505-prod/button/playing.gif" alt=""/>
      <img v-else style="width: calc(28 / 375 * 100vw);height:calc(17 / 375 * 100vw);margin-top:calc(12 / 375 * 100vw);margin-left:calc(11 / 375 * 100vw)"
       src="/assets/~/media/images/activity/film2505-prod/button/gif-img.png" alt=""/>
      <div class="audio-text show">
        <img v-if="isAudioPlaying" src="/assets/~/media/images/activity/film2505-prod/button/mob/audio-playing.png" alt=""/>
        <img v-else src="/assets/~/media/images/activity/film2505-prod/button/mob/audio-paused.png" alt=""/>
      </div>
    </div>
    <!-- <div class="icons-pc" v-show="showIcon" @click="playFullVideo">
      <a><img class="icon" src="/assets/~/media/images/activity/tianweb/mob/play.png" alt=""></a>
    </div> -->
    <img @click="playFullVideo" v-show="!showFullVideo" class="mob-video-img" src="/assets/~/media/images/activity/film2505-prod/mob/video-cover.jpg"
              code-ga="event, PAGEURL, mob_视频播放"
              code-stm="event, PAGEURL, mob_视频播放">
    <!-- 完整视频 -->
    <video width="100%" v-show="showFullVideo" ref="videoPlayerFull" id="videoPlayerFull1" class="mob-video"
      :muted="false" controls playsinline></video>
    <!-- 关闭按钮 -->
    <img v-show="showFullVideo" @click="closeVideoPc()" class="close-btn-mob"
      code-ga="event, PAGEURL, mob_视频关闭"
      code-stm="event, PAGEURL, mob_视频关闭"
      src="/assets/~/media/images/activity/tian/close.png" alt="">


    <div class="cover" v-show="isShowCover">
      <div class="pop">
        <div class="pop-video" v-show="isShowVideo">
          <video
            ref="videoPlayerFull2" id="videoPlayerFull2"
            class="my-video"

            :autoplay="true"
            :loop="false"
            :muted="false"
            direction="0"
            controls
            playsinline
          ></video>
        </div>
        <i
          :class="['el-icon-error', 'error-icon', 'cursor-p']"
          @click="hideCover"
          code-ga="event,PAGEURL, mob视频_关闭弹窗"
          code-stm="event, PAGEURL, mob视频_关闭弹窗"
        ></i>
      </div>
    </div>

    <!-- 开头金弹窗
    <el-dialog title="" :visible.sync="isShowGold" append-to-body >
        <div class="gold-cover" v-show="isShowGold" @click="closePop" code-stm="event, PAGEURL页面, 关闭提示弹窗"></div>
        <img src="/assets/~/media/images/activity/film2505-prod/mob/gold-close.png"
            class="gold-el-icon-close el-icon-close-mob" @click="closePop" style="z-index: 9999;"
            code-stm="event, PAGEURL页面, 关闭提示弹窗">
        <div class="gold-pop">
          <img src="/assets/~/media/images/activity/film2505-prod/mob/gold-popup.png" alt="">
        </div>
        <div class="click-area" @click="closePopAndPlayVideo" code-stm="event, PAGEURL页面, 关闭提示弹窗并播放视频"></div>
    </el-dialog>-->
  </div>
</template>

<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
export default {
  props: {
    isAudioPlaying: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isShowGold:false,
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      videoVisible: false,
      isWxAndroid: false,
      videoSrc: "",

      showIcon: true,
      showFullVideo: false,
      preText: 'https://www.kia.cn',

      previewImgUrl: '/assets/~/media/images/activity/tianweb/mob/mob-fengmian.png',
      fullVideoUrl: "https://img.kia.cn/media/videos/202506/dadianying-all-guanwang.mp4",

      isShowVideo: false,
      isShowCover: false,
      showvideoPlayerFull2:false,
    };
  },
  components: {},
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true
      } else {
        return false
      } //判断是否Safari浏览器
    }
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // },
  },
  watch: {
    videoVisible(n) {
      if (!n) {
        this.close()
      }
    }
  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    } else {
      this.preText = 'https://www.kia.cn'
    }
    this.$refs.videoPlayerFull.addEventListener('ended', this.restartPreviewVideo);
  },
  destroyed() {
    // window.removeEventListener("resize", this.setResize);
  },
  methods: {
    handleAudio(){
      this.$refs.videoPlayerFull.pause();
      // 触发音频播放/暂停事件
      if (!this.isAudioPlaying) {
        this.$emit("playAudio");
      } else {
        this.$emit("stopAudio");
      }
      if(!this.isAudioPlaying){
        stm_clicki("send",'event',window.location.href, "点击", '播放音频');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '播放音频', 1]);
      }else{
        stm_clicki("send",'event',window.location.href, "点击", '暂停音频');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '暂停音频', 1]);
      }
    },
    closePopAndPlayVideo(){
      this.isShowGold=false
      this.showIcon = false;
      this.showFullVideo = true;
      this.$refs.videoPlayerFull.src = this.fullVideoUrl;
      this.$refs.videoPlayerFull.play();
    },
    closePop(){
      this.isShowGold = false
    },
    play2(){
      this.$refs.videoPlayerFull.pause();
      this.isShowVideo= true;
      this.isShowCover= true;
      this.showvideoPlayerFull2 = true;
      this.$refs.videoPlayerFull2.src = this.fullVideoUrl;
      this.$refs.videoPlayerFull2.play();
    },
    closeVideoPc() {
      this.showIcon = true;
      this.showFullVideo = false;
      this.$refs.videoPlayerFull.pause();
    },
    playFullVideo() {
      this.$emit("stopAudio");
      this.$emit("distinctive", true);
      this.showIcon = false;
      this.showFullVideo = true;
      this.$refs.videoPlayerFull.src = this.fullVideoUrl;
      this.$refs.videoPlayerFull.play();
    },
    restartPreviewVideo() {

      this.showIcon = true;
      this.showFullVideo = false;
    },
    show() {
      this.isShowVideo = true;
      this.isShowCover = true;
    },
    hideCover() {
      this.isShowVideo = false;
      this.isShowCover = false;
      this.$refs.videoPlayerFull2.pause();
    },
    close() {
      this.$emit("open");
      this.videoVisible = false;
      let hideobj = document.getElementById("hidebg");
      hideobj.style.display = "none";
    },
    playVideo(index) {
      let videos = document.querySelectorAll(".swiper-video");
      console.log(123123, index, isNaN(index));
      if (videos.length > 0 && !isNaN(index)) {
        videos[index].play();
      }
    },
    // pauseVideo(index) {
    //   let videos = document.querySelectorAll(".swiper-video");
    //   if (videos.length > 0 && !isNaN(index)) {
    //     videos[index].pause();
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.twopage-pc {
  width: 100%;
  height: calc(1080 / 1920 * 100vw);
  margin-top: -1px;
}

.twopage-mob {
  position: relative;
}

.twopage {
  position: relative;
  height: calc(830 / 375 * 100vw);
  width: 100%;
  user-select: none;
  // background-image: url('../../assets/images/sportage/1.jpg');
  // background-repeat: no-repeat;
  /* 防止重复 */
  // background-position: center; /* 图片居中 */
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1px;
}
.background-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.play-audio {
    position: absolute;
    bottom: calc(5 / 375 * 100vw);
    left:calc(35 / 375 * 100vw);
    width: calc(50 / 375 * 100vw);
    height: calc(59 / 375 * 100vw);
    z-index: 99;
    img {
      position: relative;
      width: 100%;
      height: 100%;
      transition: transform 0.5s ease;
      z-index: 1000;
      &.rotate {
        animation: rotate 3s linear infinite;
      }
    }

    .audio-text {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(50 / 375 * 100vw);
      height: calc(59 / 375 * 100vw);
      // transform: translateX(-20px);
      opacity: 0;
      transition: all 0.3s ease;
      pointer-events: none;
      z-index:999;
      &.show {
        // transform: translateX(10px);
        opacity: 1;
      }

      img {
        width: 100%;
        height: 100%;
        animation: none;
      }
    }
  }

// mob start
.mob-text-box {
  position: absolute;
  width: 100%;
  top: 28.12vw;
  color: white;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mob-text-row {
  padding: calc(16 / 767 * 100vw);
  font-size: calc(24 / 767 * 100vw);
  font-family: 'zhonghei';

}

//pc
.pc-text-box {
  height: calc(657 / 1920 * 100vw);
  top: calc(50% - 337 / 1920 * 100vw);

  width: calc(662 / 1920 * 100vw);
  //   height: calc(574 / 1920 * 100vw);
  position: absolute;
  left: 0;
  //   top: calc(50% - 290 / 1920 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: calc(70 / 1920 * 100vw) calc(30 / 1920 * 100vw) calc(70 / 1920 * 100vw) calc(110 / 1920 * 100vw);
  padding-left: calc(120 / 1920 * 100vw);
  //设置间距,内容高度
  padding-top: calc(150 / 1920 * 100vw);
  padding-bottom: calc(140 / 1920 * 100vw);

}

.pc-text-row {
  color: white;
  font-size: calc(24 / 1920 * 100vw);
  font-family: 'zhonghei';
  letter-spacing: calc(3 / 1920 * 100vw);
}

.pc-video {
  width: 100%;
  height: calc(1080 / 1920 * 100vw);
}

.kv-title {
  position: absolute;
  z-index: 99;
  top: calc((1292) / 1920 * 100vw);
  left: calc(50% - 421 / 1920 * 100vw);
  width: calc(842 / 1920 * 100vw);
  height: calc(160 / 1920 * 100vw);
  // left: calc(（50% - 246.5 / 1920 * 100vw );
}

.play-button {
  position: absolute;
  z-index: 99;
  top: calc((1891) / 1920 * 100vw);
  left: calc(50% - 105 / 1920 * 100vw);
  width: calc(210 / 1920 * 100vw);
  height: calc(59 / 1920 * 100vw);
  cursor: pointer;
}

.mob-video-img {
  position: absolute;
  top: calc(268 / 375 * 100vw);
  left: calc(28 / 375 * 100vw);
  height: calc(180 / 375 * 100vw);
  width: calc(320 / 375 * 100vw);
}

.mob-video {
  position: absolute;
  top: calc(268 / 375 * 100vw);
  left: calc(28 / 375 * 100vw);
  height: calc(180 / 375 * 100vw);
  width: calc(320 / 375 * 100vw);
  object-fit: contain;
}

.icons-pc {
  position: absolute;
  top: calc(50% - 100 / 1920 * 100vw);
  // right: calc((90 + 599 - 40) / 1920 * 100vw );
  z-index: 99;
  width: calc(260 / 1920 * 100vw);
  height: calc(260 / 1920 * 100vw);

  a {
    .icon {
      display: block;
      width: calc(260 / 1920 * 100vw);
      height: calc(260 / 1920 * 100vw);
      // background: url('../../assets/images/video-play.png') no-repeat;
      // background-size: 100% 100%;
      // color: #fff;
    }
  }
}

.video-container {
  width: 100%;
  height: 100vh;
  z-index: -1;
  position: relative;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#hidebg {
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: #000;
  width: 100%;
  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  filter: alpha(opacity=60);
  /*设置透明度为60%*/
  opacity: 0.6;
  /*非IE浏览器下设置透明度为60%*/
  display: none;
  z-index: 2;
}

.video-close {
  margin-top: 20px;
  text-align: center;
}

.video-close2 {
  margin-top: 0;
}

.swiper-video-safari {
  margin-top: -40px;
}

.icon-close {
  font-size: 30px;
}

.icons {
  position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  top: calc(50% - 50px);
  left: calc(50% - 25px);
  z-index: 99;

  a {
    .icon {
      display: block;
      width: 50px;
      height: 50px;
      background: url('../../assets/images/video-play.png') no-repeat;
      background-size: 100% 100%;
      color: #fff;
    }
  }
}

// img {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }

.swiper-container {
  height: 100vh;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .el-dialog {
  width: 90% !important;
  margin: 0 auto !important;
  background: #000;
}

@media screen and (orientation: portrait) {

  //隐藏掉鼠标悬浮出现的左右切换按钮
  ::v-deep .el-carousel__arrow {
    display: none;
  }

  ::v-deep .el-dialog {
    width: 75% !important;
  }

  .video-container {
    height: 100vh;

    .swiper-container {
      height: 100vh;

      video {
        object-fit: contain;
      }
    }

    .video-close {
      position: absolute;
      /* bottom: -30vw; */
      left: 50%;
      transform: translate(-50%);
    }

  }
}

.threepage {
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .txt {
    text-align: left;
    position: absolute;
    top: 12.5vw;
    left: 8.3vw;
    color: white;
    z-index: 999;
    text-align: left;

    h3 {
      color: white;
      font-size: calc(48 / 1920 * 100vw);
      font-weight: 600;
      line-height: 1.2;
      margin-bottom: 10px;
      opacity: 1;
    }

    span {
      font-size: calc(24 / 1920 * 100vw);
      font-weight: 400;
    }

    button {
      border: 1px solid #fff;
      width: 7.9166vw;
      height: 2.9166vw;
      opacity: 1;
      transition: all 0.3s linear;
      background: rgba(0, 0, 0, 0);
      // display: flex;
      // align-items: center;
      // justify-content: center;
      font-size: 0.8333vw;
      color: #fff;
      cursor: pointer;
      display: block;
      transition: opacity 0.3s linear 0s;
      margin-top: 70px;
    }
  }

  .txtsj {
    position: absolute;
    top: 15vw;
    left: 7.53vw;
    color: white;
    z-index: 999;
    text-align: left;

    h3 {
      color: white;
      font-size: calc(26 / 375 * 100vw);
      font-weight: 600;
      line-height: 2;
      opacity: 1;
    }

    span {
      font-size: calc(14 / 375 * 100vw);
    }

    button {
      border: 1px solid #fff;
      background: rgba(0, 0, 0, 0);
      width: 105px;
      height: 40px;
      min-width: unset;
      min-height: unset;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 400;
      margin-top: 10.66vw;
      display: block;
    }
  }

  .txt1 {
    position: absolute;
    bottom: 10vw;
    left: 50%;
    transform: translate(-50%, 0);
    color: white;
    z-index: 999;
    text-align: center;

    h3 {
      color: #fff;
      line-height: 1.5;
    }
  }

  .txtsj1 {
    width: 100vw;
    position: absolute;
    bottom: calc(110 / 758 * 100vh);
    left: 50%;
    transform: translate(-50%, 0);
    color: white;
    z-index: 999;
    text-align: center;

    h3 {
      color: #fff;
      line-height: 1.5;
    }
  }

  #hidebg {
    position: absolute;
    left: 0px;
    top: 0px;
    background-color: #000;
    width: 100%;
    /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
    filter: alpha(opacity=60);
    /*设置透明度为60%*/
    opacity: 0.6;
    /*非IE浏览器下设置透明度为60%*/
    display: none;
    z-index: 2;
  }

  .video-close {
    margin-top: 20px;
    text-align: center;
  }

  .video-close2 {
    margin-top: 0;
  }

  .swiper-video-safari {
    margin-top: -40px;
  }

  .icon-close {
    font-size: 30px;
  }

  .icons {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;

    a {
      .icon {
        display: block;
        width: 50px;
        height: 50px;
        background: url('../../assets/images/video-play.png') no-repeat;
        background-size: 100% 100%;
        color: #fff;
      }
    }
  }

  // img {
  //   width: 100%;
  //   height: 100%;
  //   object-fit: cover;
  // }

  .swiper-container {
    height: 100vh;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  /* .icons {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 999;

      a {
        .icon {
          display: block;
          width: 50px;
          height: 50px;
          background: url('../../assets/images/video-play.png') no-repeat;
          color: #fff;
        }
      }
    } */
}

::v-deep .el-carousel__indicators {
  // display: none;
  bottom: 60px;
}

::v-deep .is-active .el-carousel__button {
  background-color: black;
}

//隐藏掉鼠标悬浮出现的左右切换按钮
// ::v-deep .el-carousel__arrow{
//   display: none;
// }
::v-deep .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0);

  i {
    font-size: 30px;
  }
}

.el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0);
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: black;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: black;
}

.cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #000000;
  z-index: 1000;

  // .el-icon-close {
  //   color: #fff;
  //   font-size: 30px;
  //   cursor: pointer;
  //   position: absolute;
  //   z-index: 99;
  //   right: 20px;
  //   top: 50px;
  // }
  .pop {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .pop-video {
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    video {
      width: 100%;
    }
  }

  .error-icon {
    position: absolute;
    left: 88%;
    // transform: translateX(-50%);
    font-size: 30px;
    top: 2%;
    color: #818181;

    &:hover {
      color: #fff;
    }
  }
}

.close-btn-pc {
  position: absolute;
  right: calc(50 / 1920 * 100vw);
  top: calc(1150 / 1920 * 100vw);
  width: calc(33 / 1920 * 100vw);
  height: calc(33 / 1920 * 100vw);
}

.close-btn-mob {
  position: absolute;
  right: calc(40 / 390 * 100vw);
  top: calc(279 / 375 * 100vw);
  width: calc(21 / 390 * 100vw);
  height: calc(21 / 390 * 100vw);
}

.gold-cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #2A2A2AC4;
    z-index: 999
  }
  .gold-el-icon-close {
      color: #fff;
      font-size: calc(30 / 375 * 100vw);
      cursor: pointer;
      position: fixed;
      z-index: 1000;
      right: calc(28 / 375 * 100vw);
      top: calc(240 / 375 * 100vw);
      width: calc(52 / 375 * 100vw);
      height: calc(24 / 375 * 100vw);
    }

    .gold-pop {
      z-index: 1000;
      position: fixed;
      top: calc(400 / 375 * 100vw);
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100vw;
      padding: 0 calc(23/375*100vw);
    }
    .click-area{
      position: fixed;
      z-index: 1001;
      right: calc(58 / 375 * 100vw);
      top: calc(310 / 375 * 100vw);
      width: calc(260 / 375 * 100vw);
      height: calc(135 / 375 * 100vw);
    }
  ::v-deep .el-dialog{
    background-color: transparent;
    box-shadow: none;
  }
  ::v-deep .el-dialog__headerbtn {
    display: none;
  }
</style>
